<div class="card-steps">
    <div class="step">{{index + 1}}º</div>
    <figure>
        <img [src]="data.icon.url" alt="">
    </figure>
    <p class="desc">
        {{data.text}}
    </p>
</div>